import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import MapaBono from '../views/Bono.vue'
import Mapa from '../views/Mapa.vue'
// import MapaPeigo from '../views/Peigo.vue'
//import MapaPeigoSucursales from '../views/PeigoSucursales.vue'

Vue.use(VueRouter)

  const routes = [
    {
      path: '*',
      name: 'About',
      component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    },
    {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/bonomies',
    name: 'MapaBono',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: MapaBono
  },
  {
    path: '/bancos',
    name: 'Mapa',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Mapa
  }
  // ,
  // {
  //   path: '/peigo',
  //   name: 'MapaPeigo',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: MapaPeigo
  // }
  // ,
  // {
  //   path: '/sucursales',
  //   name: 'MapaPeigoSucursales',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: MapaPeigoSucursales
  // }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
